export default __webpack_public_path__ + "static/media/indecision-app.348d005f.jpg";